export const API_BASE_URL =
  window.__FAPITEC_CONFIG__?.apiBaseUrl ||
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.PROD ? window.location.origin : 'http://localhost:3000');
